<template>
  <bingo/>
</template>

<script>
import bingo from '@/components/bingo'
export default {
  components: {
    bingo
  }
}
</script>

<style>
</style>
